import React from 'react';
import Header, { HeaderItem } from './components/header';
import { ContainerTable } from './index.styled';
import HomeDashboardPageQuery from '../../../models/home-dashboard-page-query.model';

interface TableProps {
    headerItems: HeaderItem[];
    handleSearch ?: (query: HomeDashboardPageQuery) => void;
    children: React.ReactNode;
    id?: string;
}
const Table: React.FC<TableProps> = ({ headerItems, children, handleSearch, id="table-devs" }) => {
    return (
        <ContainerTable id={id}>
            <Header headerItems={headerItems} handleSearch={handleSearch}/>
            {children}
        </ContainerTable>
    );
}

export default Table;